import React from 'react'
import { Link } from 'react-router'
import { PATH_ZTB_BUY } from '../constant'
import { goAddNewPlan } from '@components/LocalMerchant/ZhiGuangTong/util'

export const ZhiTuiBao = (
  <span>
    当前暂无套包，请<Link to={PATH_ZTB_BUY}>立即购买</Link>
  </span>
)

export const ZhiGuangTong = (
  <span>
    当前暂无计划，<a
      onClick={() => {
        goAddNewPlan()
      }}
    >
      立即新建
    </a>
  </span>
)

export default ({ content }) => (
  <div className="text-center">
    <img src="//qnm.hunliji.com/Fv4ldQuvuOCo7ODNuLJu1yEfDU5h" />
    <div>
      <span>{content}</span>
    </div>
  </div>
)
